class Http {
    public get(url: string): Promise<Response> {
        return this.fetch('GET', url);
    }

    public post(url: string, data: any = null): Promise<Response> {
        return this.fetch('POST', url, data);
    }

    private fetch(
        method: string,
        url: string,
        data: any = null
    ): Promise<Response> {
        const options: RequestInit = {
            method
        };

        const requestContext = (window as any).__litium.requestContext;
        const requestHeaders: HeadersInit = new Headers();
        requestHeaders.append(
            'litium-request-context',
            JSON.stringify(requestContext)
        );
        options.headers = requestHeaders;
        if (data != null) {
            options.body = this.CreateUrlSearchParams(data);
        }

        return fetch(url, options).then(this.checkStatus);
    }

    private CreateUrlSearchParams(source: object): URLSearchParams {
        const data: URLSearchParams = new URLSearchParams();
        Object.entries(source).forEach(([key, value]) =>
            data.append(key, value)
        );
        return data;
    }

    private checkStatus(response: Response) {
        if (response.ok && response.status >= 200 && response.status < 300) {
            return response;
        } else {
            throw new Error(response.statusText);
        }
    }
}

export default new Http();
